import React from 'react';
import {Link} from 'react-router-dom';
import securityService from '../security/security.service';

export default function ProtectedMenu(props)
{        

    
    const handleMenuClick = (e) => {
        console.log('menuclickeds')
        if (window.innerWidth < 992) {
          const link = e.target.closest('.nav-link');
          console.log(link)
          if (link) {
            console.log('closing sidebar');
    
            // document.body.classList.remove(
            //   'sidebar-open',
            //   'sidebar-collapse'
            // );
    
            // const sidebar = document.querySelector('.main-sidebar');
            // if (sidebar) {
            //   sidebar.style.transform = 'translateX(-250px)';
    
              setTimeout(()=>{
        // sidebar.style.transform = 'translateX(0)';
        document.getElementById('pushmenu-bar').click()
              },1000)
            // }
          }
        }
      };
    console.log('props: ', securityService.canUserAccess(props?.name) ,props.name );
    // const canAccess = false;
    // const canAccess =  securityService.canUserAccess(props?.name);
    const canAccess = props?.name === true 
  ? true 
  : (props?.name === false ? false : securityService.canUserAccess(props?.name));


    // Get All Menu Items
    // If can access then filter 
        
    if(canAccess){
        return (
            <li className='nav-item'>
            <Link
             to={props.to}
              className='nav-link'
              onClick={handleMenuClick}
              >
              <i className='fas fa-external-link-alt nav-icon' />
              <p>{props.displayName}</p>
            </Link>
          </li>
        );
    }
    else {
        return(
            <></>
        )
    }
    
}